function determineKeyForValue(value) {
  switch (value) {
    case 0:
      // I18n keys for 0 could be the following;
      return ['zero', 'none', 'other'];

    case 1:
      // I18n keys for 1 could be the following
      return ['one'];
  }

  // I18n keys for anything else could be the following
  return ['other'];
}

export default function pluralize(possibleValues, number) {
  var possibleKeys = determineKeyForValue(number);

  // Maybe this isn't actually a multiple choice value.
  if (typeof possibleValues === 'string') {
    return possibleValues;
  }

  // Loop through all the possible keys for this value.
  for (const key of possibleKeys) {
    if (typeof possibleValues[key] === 'undefined') {
      continue;
    }
    return possibleValues[key];
  }

  return possibleValues;
}
